import { useCallback, useState } from 'preact/hooks';

import { RequestPublicGuestlistBody } from '../types';
import { requestPublicGuestlist } from '../api';

type ReturnType = [
  (
    requestBody: RequestPublicGuestlistBody,
  ) => Promise<{ errorMessage: string | null }>,
  { isLoading: boolean; errorMessage: string | null },
];

export const useRequestPublicGuestlist = ({
  clubId,
}: {
  clubId: number;
}): ReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<
    string | null
  >(null);

  const requestGuestlist = useCallback(
    async (requestBody: RequestPublicGuestlistBody) => {
      setIsLoading(true);

      const response = await requestPublicGuestlist(
        clubId,
        requestBody,
      );

      if (response.ok) {
        setErrorMessage(null);
        return { errorMessage: null };
      }

      let message =
        'Something went wrong, please try again';

      if (response.status === 409) {
        message = `There is already a request for this event with email: ${requestBody.email}`;
        setErrorMessage(message);
      } else if (response.status === 400) {
        message = 'Invalid request';
        setErrorMessage(message);
      } else {
        setErrorMessage(message);
      }

      return { errorMessage: message };
    },
    [clubId],
  );

  return [requestGuestlist, { isLoading, errorMessage }];
};
